// final

import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import LoginPage from "./components/LoginPage";
import UnityRoom from "./components/TherapyRooms/UnityRoom";
import TestPage from "./components/TherapyRooms/TestPage";
import AIDevTestPage from "./components/TherapyRooms/AIDevTestPage";
import AdminPage from "./pages/admin/AdminPage";
import allowedUserIds from "./pages/admin/adminConfig";
import ClientTherapyRooms from "./components/TherapyRooms/ClientTherapyRooms";
import TherapistTherapyRooms from "./components/TherapyRooms/TherapistTherapyRooms";
import CreateMeetingDashboard from "./pages/admin/CreateMeetingDashboard";
import UpdateMeetingDashboard from "./pages/admin/UpdateMeetingDashboard";
import AdminResendPasswordDashboard from "./pages/admin/AdminResendPasswordDashboard";
import AdminScheduling from "./pages/admin/AdminScheduling";
import AdminRegisterUser from "./pages/admin/AdminRegisterUser";
import DemoPage from "./components/Demo/DemoPage";
import PresignLinkGenerator from "./pages/admin/PresignLinkGenerator/PresignLinkGenerator";
import RegisterCompanion from "./components/RegisterationForms/RegisterCompanion";
import RegisterTherapy from "./components/RegisterationForms/RegisterTherapy";
import RegisterTherapyOnly from "./components/RegisterationForms/RegisterTherapyOnly";
import RegisterTherapist from "./components/RegisterationForms/RegisterTherapist";
import RegisterSelect from "./components/RegisterationForms/RegisterSelect";
import SurveyForm from "./components/RegisterationForms/SurveyForm";
import AIBotPage from "./pages/AIBot/AIBotPage";
import SpaceSelection from "./components/SpaceSelection/SpaceSelection";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import TherapistScheduling from "./pages/therapistAdmin/TherapistScheduling";
import TherapistPresignLinkGenerator from "./pages/therapistAdmin/PresignLinkGenerator/TherapistPresignLinkGenerator";
import Env from "./runtimeEnv";
import HelpCenter from "./components/HelpCenter/HelpCenter";
import HelpCenterDetail from "./components/HelpCenter/HelpCenterDetail";
import SessionFeedbackModal from "./components/SessionFeedbackModal";

import axios from "axios";

function App() {
  const navigate = useNavigate();

  const {
    currentNickname,
    setCurrentNickname,
    PlutonicuserID,
    setPlutonicuserID,
    isAuthenticated,
    setIsAuthenticated,
    isAdmin,
    setIsAdmin,
    userType,
    setUserType,
    loading,
    setLoading,
    currentFormType,
    setCurrentFormType,
    surveyCompleted,
    selectedTherapyType,
    handleLogout,
  } = useContext(AuthContext);

  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    const storedUserType = localStorage.getItem("userType");
    if (storedUserType) {
      setUserType(storedUserType);
    }
  }, []);

  const idleTimeout = 60 * 60 * 1000; // Idle timeout duration (10 minutes)
  let idleTimer = null;

  // Synchronize state with localStorage on app load
  useEffect(() => {
    const restoreSession = async () => {
      const savedNickname = localStorage.getItem("currentNickname");
      const savedPlutonicuserID = localStorage.getItem("PlutonicuserID");
      const lastActiveTime = localStorage.getItem("lastActiveTime");
      const sessionActive = sessionStorage.getItem("sessionActive");

      if (lastActiveTime) {
        const now = new Date();
        const lastActiveDate = new Date(lastActiveTime);
        const differenceInMinutes = Math.floor(
          (now - lastActiveDate) / (1000 * 60)
        );

        // If more than 5 minutes have passed since the last activity
        if (differenceInMinutes >= 60) {
          handleLogout();
          return;
        }
      }

      if (!sessionActive) {
        sessionStorage.setItem("sessionActive", "true");
        setIsAuthenticated(false);
      } else if (savedNickname && savedPlutonicuserID) {
        setCurrentNickname(savedNickname);
        setPlutonicuserID(savedPlutonicuserID);
        setIsAuthenticated(true);
        setIsAdmin(allowedUserIds.includes(savedPlutonicuserID));
        const storedUserType = localStorage.getItem("userType");
        if (storedUserType) setUserType(storedUserType);

        const lastVisitedPage = localStorage.getItem("lastVisitedPage") || "/";
        const currentPath = window.location.pathname;
        if (lastVisitedPage && currentPath === "/" && !currentPath.startsWith("/admin")) {
          navigate(lastVisitedPage, { replace: true });
        }
      }

      setLoading(false); // End loading once the session is restored
    };

    restoreSession();
  }, [navigate]);

  // Idle timeout handler
  const resetIdleTimer = () => {
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(() => {
      handleLogout(); // Logout user if idle
    }, idleTimeout);
  };

  // Handle tab close to set online status to false
  /* useEffect(() => {
    const handleTabClose = () => {
	  // prevent this from being triggered more than once
	  if (window.sentOffline) return;
      window.sentOffline = true;
		
      const lastActiveTime = new Date().toISOString();
      localStorage.setItem("lastActiveTime", lastActiveTime);

      const meetingID = sessionStorage.getItem("meetingID");
      const PlutonicuserID = localStorage.getItem("PlutonicuserID");

      if (meetingID && PlutonicuserID) {
        const payload = { meetingID, online: false };

        navigator.sendBeacon(
          `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${PlutonicuserID}`,
          JSON.stringify(payload)
        );
      }
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, []); */

  // useEffect(() => {
  //   const handleOfflineTrigger = () => {
  //     const meetingID = sessionStorage.getItem("meetingID");
  //     const PlutonicuserID = localStorage.getItem("PlutonicuserID");

  //     if (!meetingID || !PlutonicuserID) return;

  //     const payload = { meetingID, userID: PlutonicuserID };

  //     navigator.sendBeacon(
  //       `${Env.REACT_APP_PYTHON_API_URL}/api/trigger-offline-summary`,
  //       JSON.stringify(payload)
  //     );
  //   };

  //   window.addEventListener("beforeunload", handleOfflineTrigger);
  //   return () =>
  //     window.removeEventListener("beforeunload", handleOfflineTrigger);
  // }, []);
  useEffect(() => {
    if (isAuthenticated) {
      const events = ["mousemove", "keypress", "click"];
      const resetTimer = () => resetIdleTimer();

      events.forEach((event) => window.addEventListener(event, resetTimer));

      // Initialize the idle timer
      resetIdleTimer();

      return () => {
        // Cleanup event listeners and timer when component unmounts
        events.forEach((event) =>
          window.removeEventListener(event, resetTimer)
        );
        if (idleTimer) clearTimeout(idleTimer);
      };
    }
  }, [isAuthenticated]);

  // Update nickname function
  const updateNickname = (nickname) => {
    setCurrentNickname(nickname);
    if (nickname) {
      localStorage.setItem("currentNickname", nickname);
      setIsAuthenticated(true);
    } else {
      localStorage.removeItem("currentNickname");
      setIsAuthenticated(false);
    }
  };

  // if (loading) {
  //   // Show a loading spinner or message while session restoration is in progress
  //   return (
  //     <div
  //       style={{
  //         height: "100vh",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //       }}
  //     >
  //       <p>Loading...</p>
  //     </div>
  //   );
  // }

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              userType?.toLowerCase() === "therapist" ? (
                <TherapistTherapyRooms />
              ) : surveyCompleted ? (
                <SpaceSelection />
              ) : (
                <SurveyForm />
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />
          }
        />

        <Route
          path="/therapy-rooms"
          element={
            isAuthenticated ? (
              (() => {
                const hasTherapyAccess = userType === "client-ai-enabled-therapy" || userType === "Client";
                
                switch (userType?.toLowerCase()) {
                  case "therapist":
                    return <Navigate to="/clients" replace />;
                  case "client":
                  case "client-ai-enabled-therapy":
                    if (!selectedTherapyType) {
                      return <SpaceSelection />;
                    }
                    return <ClientTherapyRooms />;
                  case "client-ai-companion":
                    return <Navigate to="/aimh" replace />;
                  default:
                    if (!hasTherapyAccess) {
                      return <Navigate to="/" replace />;
                    }
                    if (!selectedTherapyType) {
                      return <SpaceSelection />;
                    }
                    return <ClientTherapyRooms />;
                }
              })()
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/clients"
          element={
            isAuthenticated ? (
              userType?.toLowerCase() === "therapist" ? (
                <TherapistTherapyRooms />
              ) : (
                <Navigate to="/" replace />
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/clients/:sessionID/overview"
          element={
            isAuthenticated ? (
              userType?.toLowerCase() === "therapist" ? (
                <TherapistTherapyRooms />
              ) : (
                <Navigate to="/" replace />
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/aimh"
          element={
            isAuthenticated ? (
              (() => {
                const hasAIAccess = userType === "client-ai-enabled-therapy" || userType === "client-ai-companion";
                
                if (!hasAIAccess) {
                  return <Navigate to="/therapy-rooms" replace />;
                }
                
                switch (userType?.toLowerCase()) {
                  case "therapist":
                    return <TherapistTherapyRooms />;
                  case "client-ai-companion":
                  case "client-ai-enabled-therapy":
                    return <ClientTherapyRooms />;
                  default:
                    return <Navigate to="/therapy-rooms" replace />;
                }
              })()
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/unity-room/:roomType"
          element={
            isAuthenticated ? <UnityRoom /> : <Navigate to="/" replace />
          }
        />

        <Route path="/testpage" element={<TestPage />} />
        <Route path="/ai-dev-test" element={<AIDevTestPage />} />
        <Route path="/demo-beach" element={<DemoPage />} />
        {/* <Route path="/npcgpttherapist888" element={
  <AIBotPage
    setCurrentNickname={setCurrentNickname}
    currentNickname={currentNickname}
    handleLogout={handleLogout}
    setFormType={setCurrentFormType}
    PlutonicuserID={PlutonicuserID}
  />
} />  */}
        <Route
          path="/admin"
          element={
            !loading && isAuthenticated && isAdmin ? (
              <AdminPage
                currentNickname={currentNickname}
                setCurrentNickname={updateNickname}
                handleLogout={handleLogout}
                setFormType={setCurrentFormType}
                PlutonicuserID={PlutonicuserID}
              />
            ) : !loading && isAuthenticated && !isAdmin ? (
              <Navigate to="/" replace />
            ) : !loading && !isAuthenticated && (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/admin/createmeeting"
          element={
            isAdmin ? <CreateMeetingDashboard /> : <Navigate to="/" replace />
          }
        />
        <Route path="/admin/schedule" element={isAdmin ? <AdminScheduling /> : <Navigate to="/" replace />} />
        <Route path="/admin/register" element={isAdmin ? <AdminRegisterUser /> : <Navigate to="/" replace />} />

        <Route
          path="/admin/updatemeeting"
          element={
            isAdmin ? <UpdateMeetingDashboard /> : <Navigate to="/" replace />
          }
        />
        <Route
          path="/admin/resendpassword"
          element={
            isAdmin ? (
              <AdminResendPasswordDashboard />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        <Route
          path="/admin/presignlinkgenerator"
          element={
            isAdmin ? <PresignLinkGenerator /> : <Navigate to="/" replace />
          }
        />
        {["/clients/schedule", "/clients/schedule/create", "/clients/schedule/update"].map((path) => (
          <Route key={path} path={path} element={
            loading ? null : isAuthenticated && userType?.toLowerCase() === "therapist"
              ? <TherapistScheduling /> : <Navigate to="/" replace />
          } />
        ))}
        <Route path="/clients/schedule/link-generator" element={
          loading ? null : isAuthenticated && userType?.toLowerCase() === "therapist"
            ? <TherapistPresignLinkGenerator /> : <Navigate to="/" replace />
        } />
        <Route path="/register" element={<RegisterSelect />} />
        <Route path="/register/ai-companion" element={<RegisterCompanion />} />
        <Route
          path="/register/ai-enabled-therapy"
          element={<RegisterTherapy />}
        />
        <Route path="/register/therapy-only" element={<RegisterTherapyOnly />} />
        <Route path="/register/therapist" element={<RegisterTherapist />} />
        <Route path="/survey" element={<SurveyForm />} />

        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />

        {process.env.NODE_ENV === "development" && (
          <Route
            path="/feedback-preview"
            element={
              <div className="min-h-screen bg-[#D8F8FF]">
                <SessionFeedbackModal isOpen onClose={() => {}} />
              </div>
            }
          />
        )}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
